import React, {Component} from 'react'
import PropTypes from "prop-types";
import 'bootstrap/dist/css/bootstrap.css';
import 'react-bootstrap-country-select/dist/react-bootstrap-country-select.css';
import PatientSelectComponent from "../single_components/PatientSelectComponent";
import MyTable from "../TableComponents/Table";
import SvGraphics from "../../assets/SvGraphics";
import doctorApi from "../../services/ApiServices/doctorApi";
import {authenticationService} from "../../services/AuthenticationService";


class Patient_Page_VisitHistory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            patientRequestsArr: [],
            patientRequestsArrNotExpanded: []
        }
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

    }

     async componentDidMount() {
         let {t, patientInfo} = this.props

         let {patientRequestsArr, patientRequestsArrNotExpanded} = this.state
         let patientRequests = patientInfo.Patient_requests ? patientInfo.Patient_requests : []
         let currentUser = authenticationService.currentUserValue;
        let docName = currentUser && currentUser.profile? currentUser.profile.First_name + ' ' +currentUser.profile.Last_name:""
         for (let i = 0; i < patientRequests.length; i++) {
             if(patientRequests[i].IsVisit){
                 let date = patientRequests[i].requestDate.split('T')[0].split('-').reverse().join('/')
                 let habits = patientRequests[i].Habits_Medicals.length > 0 ? patientRequests[i].Habits_Medicals[0] : {}
                 let indication = patientRequests[i].Patient_type_indications.length > 0 ? patientRequests[i].Patient_type_indications[0] : {}
                 let response = await doctorApi.getVisitSummaryReport(patientRequests[i].RequestID)
                 if (i === 0) {
                     patientRequestsArrNotExpanded.push(
                         {
                             Visit_Date: date,
                             Type: indication.Type_of_visit,
                             Visit_Summary: habits.visit_summary,
                             fileUrl: response ? response.data.fileUrl : "",
                             CGIC: "",
                             By: docName,
                             RequestID: patientRequests[i].RequestID,
                         }
                     )
                 }
                 patientRequestsArr.push(
                     {
                         Visit_Date: date,
                         Type: indication.Type_of_visit,
                         Visit_Summary: habits.visit_summary,
                         fileUrl: response ? response.data.fileUrl : "",
                         CGIC: "",
                         By: docName,
                         RequestID: patientRequests[i].RequestID,
                     }
                 )
             }


             this.setState({patientRequestsArr, patientRequestsArrNotExpanded})
             }

     }

    getColumns = (t) => {
        return [
            {accessor: 'Visit_Date', Header: t('patientPage.lastVisitDate'), resizable: false, width: 250},
            {accessor: 'Type', Header: t('patientPage.type'), resizable: false, width: 250},
            {accessor: 'Visit_Summary', Header: t('patientPage.Discussion_and_summary'), resizable: false, width: 850},
            // {accessor: 'CGIC', Header: t('patientPage.CGIC'), resizable: false, width: 150},
            {accessor: 'By', Header: t('patientPage.By'), resizable: false, width: 200},
            {
                accessor: 'fullSummary', Header: "", resizable: false, width: 110, Cell: ({original}) => {
                    return (
                        <>
                            {original.fileUrl && <SvGraphics svgname={'pdf-icon-blue'}
                                                             onClick={() => window.open(original.fileUrl, '_blank')}
                                                             style={{height: '15px', width: '15px', cursor:'pointer'}}/>
                            }
                            {original.fileUrl && <label
                                onClick={() => window.open(original.fileUrl, '_blank')} style={{color: '#005f7f', cursor:'pointer'}}>Full Summary</label>
                            }
                        </>
                    )
                }
            },
        ]
    }

    render() {
        let {patientRequestsArr, patientRequestsArrNotExpanded} = this.state
        let {t, isExpanded, patientInfo, showDemo} = this.props
        let columns = this.getColumns(t)
        if (showDemo) {
            patientRequestsArrNotExpanded=[
                {
                    Visit_Date: "03/11/2021",
                    Type: "רגיל",
                    Visit_Summary: "ירידה במינון ליריקה במשך חודש במידה והכל תקין תחזור לחידוש רישיון בעוד 6 חודשים.",
                    CGIC: "",
                    By: "דר\" ישראלי"
                }]
        }

        return (
            <div className={'formBoxes_patientPage-Table'}>

                <MyTable
                    data={isExpanded ? patientRequestsArr : patientRequestsArrNotExpanded}
                    initialData={isExpanded ? patientRequestsArr : patientRequestsArrNotExpanded}
                    columns={columns}
                    defaultPageSize={6}
                    hasShowInfo={false}
                    hasMore={false}
                />
            </div>
        )
    }
}

Patient_Page_VisitHistory.propTypes = {
    isDisabled: PropTypes.bool
}

export default Patient_Page_VisitHistory;
